module.exports = __webpack_public_path__ + "static/media/tabs_back.46ae19e6.svg";